import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './style.css';

function ListSimple(props) {
    const { t, i18n } = useTranslation();

    const { 
        inputParam_Item = null,
        inputParam_ItemFields = null,
    } = props;

    return (
                <div className="col-auto d-flex">
                    {
                        inputParam_ItemFields && inputParam_ItemFields.map((field, index) => (
                            <div style={{width: "120px"}} className={`border-start border-end ${(inputParam_ItemFields.length !== index)? "px-0" : "ps-2" }`} key={index}>
                                <div className="border-bottom">
                                    <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-field-${field}`) }</b></Col>
                                </div>
                                {
                                    inputParam_Item.l_vals.map((val, index) => (
                                        <div key={index} dataserie-value-id={val.id} className={`border-bottom my-1 px-2 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                            {          
                                                field === "serieTime" &&
                                                <>
                                                    {val["serieTimeStr"]  !== null ? val["serieTimeStr"] : val["serieTime"]}
                                                </>
                                            }
                                            {
                                                field !== "serieTime" &&
                                                <>
                                                    {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18n.language) : val[field])  : t('no-data')}`}
                                                    {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                </>
                                            }
                                        </div>
                                    ))
                                }
                                {
                                    inputParam_Item.l_vals.length === 0 && 
                                        <div className="text-center">{t('no-data')}</div>
                                }
                            </div>
                        ))
                    }
                </div>
      );
}

ListSimple.propTypes = {
    inputParam_Item: PropTypes.object.isRequired,
    inputParam_ItemFields: PropTypes.array.isRequired,
};

export default ListSimple;